import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "prefix", "suffix", "onChange", "thousandSeparator", "allowNegative", "format", "decimalScale", "fixedDecimalScale", "aria-labelledby", "maxValue", "error", "helperText"],
  _excluded2 = ["onChange", "name", "prefix", "suffix", "thousandSeparator", "decimalScale", "fixedDecimalScale"];
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import { Input as MuiInput, InputAdornment as MuiInputAdornment, FormHelperText } from "@mui/material";
import { RaiseColors } from "componentLibrary";
import { MAX_INT_VALUE } from "utils/constants";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var NumberInput = function NumberInput(_ref) {
  var value = _ref.value,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$thousandSeparato = _ref.thousandSeparator,
    thousandSeparator = _ref$thousandSeparato === void 0 ? true : _ref$thousandSeparato,
    _ref$allowNegative = _ref.allowNegative,
    allowNegative = _ref$allowNegative === void 0 ? false : _ref$allowNegative,
    format = _ref.format,
    decimalScale = _ref.decimalScale,
    _ref$fixedDecimalScal = _ref.fixedDecimalScale,
    fixedDecimalScale = _ref$fixedDecimalScal === void 0 ? false : _ref$fixedDecimalScal,
    ariaLabelledby = _ref["aria-labelledby"],
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? MAX_INT_VALUE : _ref$maxValue,
    _ref$error = _ref.error,
    externalError = _ref$error === void 0 ? false : _ref$error,
    helperText = _ref.helperText,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    internalError = _useState2[0],
    setInternalError = _useState2[1];
  useEffect(function () {
    if (maxValue) {
      var numValue = _parseFloat(String(value));
      if (!isNaN(numValue) && numValue > maxValue) {
        setInternalError(true);
      } else {
        setInternalError(false);
      }
    } else {
      setInternalError(false);
    }
  }, [value, maxValue]);
  var hasError = internalError || externalError;
  var displayHelperText = helperText || (internalError ? "Value exceeds maximum limit" : undefined);
  var startAdornment, endAdornment;
  if (prefix) {
    startAdornment = /*#__PURE__*/_jsx(MuiInputAdornment, {
      style: {
        marginLeft: "16px"
      },
      position: "start",
      children: prefix
    });
  }
  if (suffix) {
    endAdornment = /*#__PURE__*/_jsx(MuiInputAdornment, {
      position: "end",
      children: suffix
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MuiInput, _objectSpread(_objectSpread({
      startAdornment: startAdornment,
      endAdornment: endAdornment,
      disableUnderline: true
    }, props), {}, {
      value: value !== null && value !== void 0 ? value : "",
      onChange: function onChange(e) {
        _onChange(e);
        if (maxValue) {
          var numValue = _parseFloat(e.target.value);
          setInternalError(!isNaN(numValue) && numValue > maxValue);
        }
      },
      inputProps: {
        thousandSeparator: thousandSeparator,
        format: format,
        decimalScale: decimalScale,
        fixedDecimalScale: fixedDecimalScale,
        allowNegative: allowNegative,
        "aria-labelledby": ariaLabelledby,
        style: {
          padding: prefix ? "8px 16px 8px 0px" : "8px 16px",
          fontSize: "14px"
        }
      },
      sx: {
        border: hasError ? "solid 1px ".concat(RaiseColors.destructive500) : "solid 1px ".concat(RaiseColors.grayscale200),
        borderRadius: "8px",
        "&:hover": {
          border: hasError ? "solid 1px ".concat(RaiseColors.destructive500) : "solid 1px ".concat(RaiseColors.grayscale900)
        },
        "&.Mui-disabled": {
          backgroundColor: RaiseColors.grayscale50,
          cursor: "not-allowed",
          "& input": {
            cursor: "not-allowed"
          }
        },
        "&.Mui-disabled:hover": {
          border: "solid 1px ".concat(RaiseColors.grayscale200)
        },
        "&.Mui-focused": {
          border: hasError ? "1px solid ".concat(RaiseColors.destructive500) : "1px solid ".concat(RaiseColors.bahama1200)
        }
      },
      error: hasError,
      inputComponent: NumberFormatCustomWrapper
    })), hasError && displayHelperText && /*#__PURE__*/_jsx(FormHelperText, {
      error: true,
      sx: {
        marginLeft: "14px",
        marginTop: "4px"
      },
      children: displayHelperText
    })]
  });
};

// uses https://www.npmjs.com/package/react-number-format
var NumberFormatCustomWrapper = /*#__PURE__*/React.forwardRef(function NumberFormatCustom(props, ref) {
  var onChange = props.onChange,
    name = props.name,
    prefix = props.prefix,
    suffix = props.suffix,
    thousandSeparator = props.thousandSeparator,
    decimalScale = props.decimalScale,
    fixedDecimalScale = props.fixedDecimalScale,
    other = _objectWithoutProperties(props, _excluded2);
  var formatedDecimalValue = function formatedDecimalValue(values) {
    var _values$value$split = values.value.split("."),
      _values$value$split2 = _slicedToArray(_values$value$split, 2),
      dollars = _values$value$split2[0],
      cents = _values$value$split2[1]; // if value is empty returns [""]
    var hasValue = !(values.value === "");
    var centsIsUndefined = cents === undefined;
    var formattedValue = null;
    if (hasValue && !centsIsUndefined) {
      var _context;
      var isSingleDigitDecimal = hasValue && cents.length < 2;
      formattedValue = isSingleDigitDecimal ? _concatInstanceProperty(_context = "".concat(dollars, ".")).call(_context, cents, "0") : values.value;
    }
    if (centsIsUndefined && dollars && dollars.length) {
      formattedValue = "".concat(dollars, ".00");
    }
    onChange === null || onChange === void 0 || onChange({
      target: {
        value: formattedValue,
        name: name
      }
    });
    return formattedValue;
  };
  return /*#__PURE__*/_jsx(NumberFormat, _objectSpread(_objectSpread({}, other), {}, {
    name: name,
    getInputRef: ref,
    prefix: prefix,
    suffix: suffix,
    thousandSeparator: thousandSeparator ? true : undefined,
    decimalScale: decimalScale,
    fixedDecimalScale: fixedDecimalScale,
    onValueChange: formatedDecimalValue
  }));
});
export default NumberInput;